<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [value]="viewItem"
          [class.ng-invalid]="viewStatus.invalid"
          [class.ng-valid]="viewStatus.valid"
          [class.ng-touched]="viewStatus.touched"
          [disabled]="viewDisabled"
          [valuePrimitive]="false"
          [textField]="'FullName'"
          [valueField]="'FullName'"
          [defaultItem]="{ FullName: config?.placeholder }"
          [filterable]="true"
          (valueChange)="pickFromView($event)"
          (blur)="blurFromView()"
          search-ex
          [seSearchColumns]="['FullName', 'Email']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.FullName === config?.placeholder"
            >
              @if (config?.options?.favoriteType && dataItem?.HRRef != null) {
                <span (click)="toggleFavorite(dataItem, $event)">
                  <i
                    class="fas fa-star"
                    title="Add/Remove Favorite Employee"
                    [ngStyle]="{
                      color: isFavorite(dataItem) ? 'orange' : 'lightgrey',
                    }"
                  ></i>
                  &nbsp;
                </span>
              }
              @if (dataItem?.IsRecommended) {
                <span
                  class="dynamic-recommended-badge"
                  title="Recommended for this company"
                  style="
                    color: var(--color-success);
                    border: 1px solid currentColor;
                    border-radius: 3px;
                    padding: 0 4px;
                    margin-right: 6px;
                    font-size: 11px;
                    align-self: center;
                  "
                >
                  Recommended
                </span>
              }
              <div>
                @if (dataItem.Name) {
                  <span class="job-name link-style">
                    {{ dataItem.FullName }}
                    @if (dataItem.Last4SSN) {
                      :
                      <span class="ryn-replay-block">
                        XXX-XX-{{ dataItem.Last4SSN }}
                      </span>
                    }
                  </span>
                }
                <div class="clearBoth">
                  <div style="display: inline-block; width: 120px">HR Ref:</div>
                  <div style="display: inline-block">
                    {{ dataItem.HRRef }}
                  </div>
                </div>
                @if (dataItem.CellPhone) {
                  <div class="clearBoth">
                    <div style="display: inline-block; width: 120px">
                      Cell Phone:
                    </div>
                    <div style="display: inline-block">
                      {{
                        showCellMask(config)
                          ? '(XXX) XXX - XXXX'
                          : dataItem.CellPhone
                      }}
                    </div>
                  </div>
                }
                @if (!config?.options?.employeePicker) {
                  <div class="clearBoth">
                    <div style="display: inline-block; width: 120px">
                      EM Designation:
                    </div>
                    <div style="display: inline-block">
                      @for (
                        i of getEMDesignationList(dataItem);
                        track $index;
                        let isLast = $last;
                        let c = $count
                      ) {
                        <span
                          [ngClass]="{
                            'font-weight-bold': c > 1 && i.IsActive === true,
                          }"
                        >
                          {{ i.EMDesignationName }}{{ isLast ? '' : ',' }}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="clearBoth">
                    <div style="display: inline-block; width: 120px">
                      File Class:
                    </div>
                    <div style="display: inline-block">
                      @for (
                        i of getFileClassList(dataItem);
                        track $index;
                        let isLast = $last;
                        let c = $count
                      ) {
                        <span
                          [ngClass]="{
                            'font-weight-bold': c > 1 && i.IsActive === true,
                          }"
                        >
                          {{ i.FileClassName }}{{ isLast ? '' : ',' }}
                        </span>
                      }
                    </div>
                  </div>
                }
                <div class="clearBoth">
                  <div style="display: inline-block; width: 120px">
                    Company:
                  </div>
                  <div style="display: inline-block">
                    @for (
                      i of getCompaniesList(dataItem);
                      track $index;
                      let isLast = $last;
                      let c = $count
                    ) {
                      <span
                        [ngClass]="{
                          'font-weight-bold': c > 1 && i.IsActive === true,
                        }"
                      >
                        {{ i.Company }}{{ isLast ? '' : ',' }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.FullName">
                <span class="job-name">{{ dataItem.FullName }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }
      @if (config?.options?.isMultiSelect) {
        <!-- [formGroup] only around the [formControlName] multi-select: on the shared wrapper it
             turns ng-invalid for ANY invalid sibling and paints the [value]-bound single-select
             red through the _forms.scss #34403 rule (PR 5721 thread 72565). -->
        <div [formGroup]="group">
          <kendo-multiselect
            upsKeepSelectionOnEsc
            [attr.name]="config.formControlName"
            [formControlName]="config.formControlName"
            class="k-no-dropdown w-100"
            [valuePrimitive]="false"
            [textField]="'FullName'"
            [valueField]="'FullName'"
            [placeholder]="config?.placeholder"
            [filterable]="true"
            (valueChange)="multiSelectValueChange($event)"
            search-ex
            [seSearchColumns]="['FullName', 'Email']"
            (seFilterChangeEx)="filterChangeItem($event)"
            [seDebounceFilterChange]="150"
            [seUseCustomLocalFilter]="true"
            [seMinSearchLength]="0"
            [loading]="isLoading"
            [tabindex]="tabindex"
          >
            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <div
                style="display: inline-flex"
                [hidden]="dataItem?.FullName === config?.placeholder"
              >
                @if (config?.options?.favoriteType && dataItem?.HRRef != null) {
                  <span (click)="toggleFavorite(dataItem, $event)">
                    <i
                      class="fas fa-star"
                      title="Add/Remove Favorite Employee"
                      [ngStyle]="{
                        color: isFavorite(dataItem) ? 'orange' : 'lightgrey',
                      }"
                    ></i>
                    &nbsp;
                  </span>
                }
                @if (dataItem?.IsRecommended) {
                  <span
                    class="dynamic-recommended-badge"
                    title="Recommended for this company"
                    style="
                      color: var(--color-success);
                      border: 1px solid currentColor;
                      border-radius: 3px;
                      padding: 0 4px;
                      margin-right: 6px;
                      font-size: 11px;
                      align-self: center;
                    "
                  >
                    Recommended
                  </span>
                }
                <div>
                  @if (dataItem.Name) {
                    <span class="job-name link-style">
                      {{ dataItem.FullName }}
                      @if (dataItem.Last4SSN) {
                        :
                        <span class="ryn-replay-block">
                          XXX-XX-{{ dataItem.Last4SSN }}
                        </span>
                      }
                    </span>
                  }
                  <div class="clearBoth">
                    <div style="display: inline-block; width: 120px">
                      HR Ref:
                    </div>
                    <div style="display: inline-block">
                      {{ dataItem.HRRef }}
                    </div>
                  </div>
                  @if (dataItem.CellPhone) {
                    <div class="clearBoth">
                      <div style="display: inline-block; width: 120px">
                        Cell Phone:
                      </div>
                      <div style="display: inline-block">
                        {{ dataItem.CellPhone }}
                      </div>
                    </div>
                  }
                  @if (!config?.options?.employeePicker) {
                    <div class="clearBoth">
                      <div style="display: inline-block; width: 120px">
                        EM Designation:
                      </div>
                      <div style="display: inline-block">
                        @for (
                          i of getEMDesignationList(dataItem);
                          track $index;
                          let isLast = $last;
                          let c = $count
                        ) {
                          <span
                            [ngClass]="{
                              'font-weight-bold': c > 1 && i.IsActive === true,
                            }"
                          >
                            {{ i.EMDesignationName }}{{ isLast ? '' : ',' }}
                          </span>
                        }
                      </div>
                    </div>
                    <div class="clearBoth">
                      <div style="display: inline-block; width: 120px">
                        File Class:
                      </div>
                      <div style="display: inline-block">
                        @for (
                          i of getFileClassList(dataItem);
                          track $index;
                          let isLast = $last;
                          let c = $count
                        ) {
                          <span
                            [ngClass]="{
                              'font-weight-bold': c > 1 && i.IsActive === true,
                            }"
                          >
                            {{ i.FileClassName }}{{ isLast ? '' : ',' }}
                          </span>
                        }
                      </div>
                    </div>
                  }
                  <div class="clearBoth">
                    <div style="display: inline-block; width: 120px">
                      Company:
                    </div>
                    <div style="display: inline-block">
                      @for (
                        i of getCompaniesList(dataItem);
                        track $index;
                        let isLast = $last;
                        let c = $count
                      ) {
                        <span
                          [ngClass]="{
                            'font-weight-bold': c > 1 && i.IsActive === true,
                          }"
                        >
                          {{ i.Company }}{{ isLast ? '' : ',' }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template kendoMultiSelectValueTemplate let-dataItem>
              <div style="display: inline-flex">
                <div kendoTooltip [title]="dataItem?.FullName">
                  <span class="job-name">{{ dataItem.FullName }}</span>
                </div>
              </div>
            </ng-template>
          </kendo-multiselect>
        </div>
      }
      @if (config?.options?.allowToggleActive) {
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="activeOnly_{{ config?.formControlName }}"
            (change)="onToggleActive()"
            [checked]="showInActive"
          />
          <label
            class="form-check-label small text-muted"
            for="activeOnly_{{ config?.formControlName }}"
          >
            Show Inactive employees
          </label>
        </div>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
